module.exports = __webpack_public_path__ + "static/media/deskDog.5b9c7f9b.jpg";